import React, { useEffect, useState, useContext } from "react";
import {
  Typography,
  Button,
  CardContent,
  CardActions,
  Grid,
  Card,
  CardMedia,
  IconButton,
} from "@mui/material";
import { getVenues, createVenue, updateVenue, deleteVenue } from "../api";
import { Delete, Edit } from "@mui/icons-material";
import VenueModal from "../components/VenueModal";
import DeleteModal from "../components/DeleteModal";
import Loader from "../components/common/Loader";
import UserContext from "../contexts/UserContext";
import config from "../config";

export default function VenuesPage() {
  const [state, setState] = useState({});

  const handleCreate = () => {
    setState((s) => ({
      ...s,
      open: true,
      venue: undefined,
      handleConfirm: async (body) => {
        const venue = await createVenue(body);
        setState((s) => ({
          ...s,
          data: [venue, ...s.data],
        }));
      },
    }));
  };

  const handleEdit = (item) => () => {
    setState((s) => ({
      ...s,
      open: true,
      venue: item,
      handleConfirm: async (body) => {
        const venue = await updateVenue(body);
        venue.timestamp = Date.now();
        s.data.splice(
          s.data.indexOf(s.data.find((x) => x.id === venue.id)),
          1,
          venue
        );
      },
    }));
  };

  const handleClose = () => {
    setState((s) => ({
      ...s,
      open: false,
      venue: undefined,
      handleConfirm: undefined,
    }));
  };

  const handleDelete = (item) => async () => {
    setState((s) => ({
      ...s,
      delete: true,
      deleteName: item.name,
      handleDeleteConfirm: async () => {
        await deleteVenue(item);
        setState((s) => ({
          ...s,
          data: [...s.data.filter((x) => x.id !== item.id)],
        }));
      },
    }));
  };

  const handleDeleteClose = () => {
    setState((s) => ({
      ...s,
      delete: false,
      deleteName: undefined,
      handleDeleteConfirm: undefined,
    }));
  };

  const userContext = useContext(UserContext);

  useEffect(() => {
    (async () => {
      if (userContext.fetchedUser) {
        const data = await getVenues(userContext.user.country);

        setState((s) => ({
          ...s,
          data,
          venueId: userContext.user.venueId,
          role: userContext.user.role,
        }));
      }
    })();
  }, [userContext]);

  return (
    <>
      <Grid
        container
        p={4}
        spacing={4}
        sx={{ maxWidth: "1600px", paddingTop: "80px" }}
        justifyContent={state.data?.length ? "left" : "center"}
      >
        {["admin"].includes(state.role) && (
          <Grid item xs={12}>
            <Button type="submit" onClick={handleCreate} variant="contained">
              Create Venue
            </Button>
          </Grid>
        )}
        {state.data ? (
          state.data.map((item) => (
            <Grid
              item
              xs={12}
              md={6}
              lg={4}
              xl={3}
              key={item.id}
              sx={{ background: "transparent" }}
            >
              <Card variant="outlined" sx={{ backgroundColor: "#4b445b" }}>
                <CardMedia
                  component="img"
                  height="200"
                  image={
                    item.timestamp
                      ? `${config.cdnUrl}/logos/${item.id}?t=${item.timestamp}`
                      : `${config.cdnUrl}/logos/${item.id}`
                  }
                  alt={item.name}
                />
                <CardContent>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="div"
                    color="secondary"
                    sx={{
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      height: "64px",
                    }}
                  >
                    {item.name}
                  </Typography>
                </CardContent>
                <CardActions>
                  {["admin"].includes(state.role) && (
                    <IconButton
                      aria-label="edit"
                      onClick={handleEdit(item)}
                      color="secondary"
                      sx={{ marginLeft: "auto" }}
                    >
                      <Edit />
                    </IconButton>
                  )}
                  {["admin"].includes(state.role) && (
                    <IconButton
                      aria-label="delete"
                      onClick={handleDelete(item)}
                      color="secondary"
                    >
                      <Delete />
                    </IconButton>
                  )}
                </CardActions>
              </Card>
            </Grid>
          ))
        ) : (
          <Loader />
        )}
      </Grid>
      {state.open && (
        <VenueModal
          venue={state.venue}
          handleConfirm={state.handleConfirm}
          handleClose={handleClose}
        />
      )}
      {state.delete && (
        <DeleteModal
          name={state.deleteName}
          handleConfirm={state.handleDeleteConfirm}
          handleClose={handleDeleteClose}
        />
      )}
    </>
  );
}
